// @ts-expect-error file not migrated yet
import { getUserCanEdit } from 'customer-data-sidebar/universal/permissions/UserPermissions';
export const getUserCanEditAssociation = object => {
  return Boolean('userPermissions' in object && getUserCanEdit(object.userPermissions) || 'currentUserCanEdit' in object && object.currentUserCanEdit);
};